<template>
	<div>
		<v-toolbar>
			<!-- <v-toolbar-title>{{selectedFile.filename}}</v-toolbar-title> -->
			<v-autocomplete
				v-model="selectedReasons"
				:items="rejectReasons"
				:allow-overflow="false"
				multiple
				flat
				placeholder="Reject with Reason"
			></v-autocomplete>
			<v-spacer></v-spacer>
			<v-autocomplete
				v-if="selectedFile.probableMetas"
				v-model="selectedProbableMeta"
				:items="getProbableMetaList()"
				:allow-overflow="false"
				flat
				placeholder="Probable Meta List"
			></v-autocomplete>
			<v-spacer></v-spacer>
			<!-- <v-btn
				v-if="this.selectedFile.extension == 'pdf'"
				outline
				flat
				color="red darken-1"
				@click="isPythonScriptConvertable"
				v-on="on"
				>IS PY CONVERT?</v-btn
			>
			<v-btn
				v-if="this.selectedFile.extension == 'pdf'"
				outline
				flat
				color="red darken-1"
				@click="downloadPythonScriptConvertableOutput"
				v-on="on"
				>DNLD PY CONVERT</v-btn
			> -->
			<template>
				<div class="text-xs-center">
					<v-menu open-on-hover offset-y>
						<template v-slot:activator="{ on }">
							<v-btn
								outline
								flat
								color="red darken-1"
								dark
								v-on="on"
							>
								Run Py Script
							</v-btn>
						</template>
						<v-list two-line dense>
							<v-list-tile @click="isPythonScriptConvertable">
								<v-list-tile-content>
									<v-list-tile-title
										>IS PYTHON SCRIPT CONVERTABLE?</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if identificationHeaders is
										custom python script convertable
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
						<v-list two-line dense>
							<v-list-tile
								@click="downloadPythonScriptConvertableOutput"
							>
								<v-list-tile-content>
									<v-list-tile-title
										>DOWNLOAD PYTHON SCRIPT CONVERTABLE OUTPUT</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if file is custom python script
										convertable and downloads output
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
						<v-list two-line dense>
							<v-list-tile
								@click="
									downloadPythonScriptDelimterConvertableOutput
								"
							>
								<v-list-tile-content>
									<v-list-tile-title
										>DELIMITER CONVERTABLE OUTPUT</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if file is custom python script
										delimiter convertable and downloads
										output
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
						<v-list two-line dense>
							<v-list-tile
								@click="downloadPDFMLAPIConvertableOutput"
							>
								<v-list-tile-content>
									<v-list-tile-title
										>DOWNLOAD PDF ML API CONVERTABLE OUTPUT</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if file is pdf ml
										convertable and downloads output
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
						<v-list two-line dense>
							<v-list-tile
								@click="downloadPDFGeminiConvertableOutput"
							>
								<v-list-tile-content>
									<v-list-tile-title
										>PDF GEMINI CONVERTABLE OUTPUT</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if file is pdf gemini
										convertable and downloads output
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>						
						<v-list two-line dense>
							<v-list-tile
								@click="downloadXlsToXlsxConvertableOutput"
							>
								<v-list-tile-content>
									<v-list-tile-title
										>DOWNLOAD XLS TO XLSX CONVERTABLE OUTPUT</v-list-tile-title
									>
									<v-list-tile-sub-title>
										Checks if an xls file can be 
										converted to xlsx
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>					
					</v-menu>
				</div>
			</template>
			<!-- <v-btn outline flat color="purple darken-1" @click="appendUnderscore"
				>UnderScore</v-btn
			> -->
			<v-btn outline flat color="blue darken-1" @click="formatConfig"
				>Format</v-btn
			>
			<v-btn
				outline
				flat
				color="yellow darken-1"
				@click="openHeaderMappingDialog"
				>HM</v-btn
			>
			<v-btn
				:disabled="disableVerify"
				outline
				flat
				color="green darken-1"
				@click="verify"
				>Verify</v-btn
			>
			<v-btn
				:disabled="disableExtractAndSave"
				outline
				flat
				color="pink darken-1"
				@click="extactAndSave"
				>Extract</v-btn
			>
			<v-btn outline flat color="red darken-1" @click="openRemardDialog">
				<v-icon>delete</v-icon>
			</v-btn>
		</v-toolbar>
		<v-expansion-panel>
			<v-expansion-panel-content>
				<template v-slot:header>
					<div class="headline font-weight-light pa-2">
						Header Mapping
						<v-btn
							color="red lighten-3"
							depressed
							@click.stop="clearHeaderMapping"
							>Clear Mapping</v-btn
						>
						<v-btn
							color="green lighten-3"
							depressed
							@click.stop="onGenerateHeaderMappingClick"
							>Generate Header Mapping</v-btn
						>
					</div>
				</template>
				<v-btn color="orange darken-1" outline @click="showMapping"
					>Generate mapping</v-btn
				>
				<v-btn color="green darken-1" outline @click="clearAllSelection"
					>Clear All</v-btn
				>
				<div
					style="overflow:scroll;text-align:center;margin:0 auto;padding:20px;"
				>
					<br />
					<template v-for="(header, i) of Object.keys(headersToBeMapped)">
						<span :key="i">{{ header }}</span>
						<v-autocomplete
							style="width:90%"
							:label="header"
							:key="header"
							:items="mapableHeaders"
							v-model="headersToBeMapped[header]"
						>
							<template v-slot:prepend>
								<v-btn
									icon
									color="red darken-3"
									flat
									@click="clearSelection(header)"
								>
									<v-icon>close</v-icon>
								</v-btn>
							</template>
						</v-autocomplete>
					</template>
					<code>{{ generatedMapping }}</code>
					<v-divider></v-divider>
				</div>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div style="overflow:scroll;">
			<brace
				style="height:90vh;"
				class="kbet-editor"
				:mode="'json'"
				@code-change="onEditorCodeChange"
				@setHandler="
					h => {
						editorHandler = h;
					}
				"
			/>
		</div>
		<v-dialog v-model="remarkDialog" max-width>
			<v-card>
				<v-card-title class="headline grey lighten-2" primary-title
					>Reject File {{ selectedFile.filename }}</v-card-title
				>

				<v-card-text>
					<p class="body-2">
						Files once rejected wont be reverted back so be sure about this.
					</p>
					<div>
						<v-select
							v-model="tag"
							:items="tags"
							label="Remark Tag"
							class="g1"
						></v-select>
						<v-text-field
							v-model="remarkText"
							label="Detailed Remark"
							ma-2
							class="g2"
						></v-text-field>
					</div>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="remarkDialog = false"
						>Cancel</v-btn
					>
					<v-btn color="orange darken-1" flat @click="remarkDialog = false"
						>Reject</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import fileMetaEditorMixins from '../../mixins/fileMetaEditorMixins';
export default {
	components: {},
	created() {},
	mixins: [fileMetaEditorMixins],
	data() {
		return {
			editorHandler: false,
			disableVerify: true,
			disableSave: true,
			disableExtractAndSave: true,
			remarkDialog: false,
			tags: [...require('../../components/tags.json')],
			tag: '',
			remarkText: '',
			headerMappingDialog: false,
			headersToBeMapped: {},
			generatedMapping: {},
			rejectReasons: [...require('../../components/rejects.json')],
			selectedReasons: [],
			selectedProbableMeta: '',
			originalMeta: {},
		};
	},
	methods: {
		...mapActions('rejectedMetaTwo', [
			'verifyMeta',
			'extractAndSaveMeta',
			'getHeaderMapping',
			'registerHeaderMapping',
			'unlockFile',
			'getFileMeta',
		]),
		...mapActions([
			'checkPythonScriptConvertable',
			'downloadPythonScriptOutput',
			'downloadPDFMLAPIConvertableOutputAPICall',
			'downloadPDFGeminiConvertableOutputAPICall',
			'downloadPythonScriptDelimiterOutput',
			'downloadXlsToXlsxConvertableOutputAPICall',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapMutations('rejectedMetaTwo', [
			'refreshStockistListEmitter',
			'closeFileMetaDialog',
		]),
		onEditorCodeChange(code) {
			this.editorCode = code;
			// this.disableVerify = true;
			this.disableSave = true;
			this.disableExtractAndSave = true;
		},
		clearHeaderMapping() {
			if (this.jsonValidate) {
				let fileMetaConfig = JSON.parse(this.editorCode);
				let conf = fileMetaConfig.alternateMeta.enabled
					? fileMetaConfig.alternateMeta
					: fileMetaConfig;
				conf.headerMapping = {};
				if (fileMetaConfig.alternateMeta.enabled) {
					fileMetaConfig.alternateMeta = conf;
					this.editorHandler.setValue(JSON.stringify(fileMetaConfig, null, 2));
				} else {
					this.editorHandler.setValue(JSON.stringify(conf, null, 2));
				}
			} else {
				this.openSnackbar({ text: 'Invalid JSON please check' });
			}
		},
		getIdHeaders(fileMetaConfig, conf) {
			if (
				fileMetaConfig.alternateMeta &&
				fileMetaConfig.alternateMeta.enabled &&
				fileMetaConfig.alternateMeta.identificationHeaders.length > 0 &&
				fileMetaConfig.alternateMeta.headerSequence.length > 0 &&
				/txt|csv/i.test(conf.extension)
			) {
				return conf.headerSequence[0].split('!').map(e => (e += ' ')) || [];
			} else if (
				fileMetaConfig.identificationHeaders.length > 0 &&
				fileMetaConfig.headerSequence.length > 0 &&
				/txt|csv/i.test(conf.extension)
			) {
				return conf.headerSequence[0].split('!').map(e => (e += ' ')) || [];
			} else {
				let idHeaders = [];
				let headerArray =
					(conf.headerSequence && conf.headerSequence.length) > 0
						? conf.headerSequence
						: conf.identificationHeaders;
				for (let header of headerArray) {
					idHeaders.push(String(header).trim());
				}
				return idHeaders;
			}
		},
		formatConfig() {
			if (this.jsonValidate(this.editorCode)) {
				let fileMetaConfig = JSON.parse(this.editorCode);
				let conf = fileMetaConfig.alternateMeta.enabled
					? fileMetaConfig.alternateMeta
					: fileMetaConfig;
				if (
					conf.identificationHeaders &&
					conf.identificationHeaders.length > 0
				) {
					let idHeaders = this.getIdHeaders(fileMetaConfig, conf);
					conf.duplicateHeaders = conf.duplicateHeaders
						? conf.duplicateHeaders
						: this.hasDuplicates(idHeaders);
					let headerMap = {};
					for (let i in idHeaders) {
						let head = idHeaders[i]
							.replace(/[&/\\#,+()$~%.'":*?<>{}!]/g, '')
							.toUpperCase();
						if (conf.duplicateHeaders) {
							head += '__' + i;
						}
						headerMap[head] = '';
					}

					if (conf.headerSequence && conf.headerSequence.length > 0) {
						conf.headerSequence = idHeaders;
						conf.identificationHeaders = conf.identificationHeaders.map(e =>
							String(e).trim()
						);
					} else {
						conf.identificationHeaders = idHeaders;
					}
					conf.actualHeaderLength = conf.identificationHeaders.length;
					conf.headerMapping = headerMap;
					if (fileMetaConfig.alternateMeta.enabled) {
						fileMetaConfig.alternateMeta = conf;
						this.updateOriginalMeta(fileMetaConfig);
						this.editorHandler.setValue(
							JSON.stringify(fileMetaConfig, null, 2)
						);
					} else {
						this.updateOriginalMeta(conf);
						this.editorHandler.setValue(JSON.stringify(conf, null, 2));
					}
					this.disableVerify = false;
				}
			} else {
				this.openSnackbar({ text: 'Invalid JSON please check' });
			}
		},
		hasDuplicates(array) {
			let valuesSoFar = Object.create(null);
			for (let i = 0; i < array.length; ++i) {
				let value = array[i];
				if (value.replace(/[&/\\#,+()$~%."":*?<>{}\s]/g, "") in valuesSoFar) {
					return true;
				}
				valuesSoFar[value.replace(/[&/\\#,+()$~%."":*?<>{}\s]/g, "")] = true;
			}
			return false;
		},
		verify() {
			this.openLoaderDialog();
			let meta = JSON.parse(this.editorCode);
			meta.enabled = 1;
			meta.stockistId = this.selectedFile.stockistId;
			meta.extension = this.selectedFile.extension;
			meta.stockistName = this.selectedFile.stockistName;
			meta.creatorName = this.userData.name;
			// tempMeta = JSON.parse(JSON.stringify(fileMetaConfig));
			this.verifyMeta({
				fileMeta: meta,
				filesToReturnAllData: this.selectedFilesForExtraction,
				...this.getSelectedDates,
			}).then(data => {
				this.closeLoaderDialog();
				if (data) {
					this.disableExtractAndSave = false;
					this.openSnackbar({ text: 'Matched Files check log' });
				} else {
					this.openSnackbar({
						text: 'Did not match any file check logs',
					});
				}
			});
		},
		async extactAndSave() {
			if (window.confirm('Are you sure you want to extract this file??????')) {
				let meta = JSON.parse(this.editorCode);
				meta.enabled = 1;
				meta.stockistId = this.selectedFile.stockistId;
				meta.extension = this.selectedFile.extension;
				meta.stockistName = this.selectedFile.stockistName;
				meta.creatorName = this.userData.name;
				meta = this.addOnlySalesAndClosingFlag(
					JSON.parse(JSON.stringify(meta))
				);
				this.openLoaderDialog();
				let ok = await this.registerHeaderMapping({
					headerMapping: meta.alternateMeta.enabled
						? meta.alternateMeta.headerMapping
						: meta.headerMapping,
				});
				if (ok) {
					this.extractAndSaveMeta({
						fileMeta: meta,
						uuids: this.selectedFilesForExtraction,
						...this.getSelectedDates,
					}).then(data => {
						this.closeLoaderDialog();
						if (data) {
							this.openSnackbar({
								text: 'Extracted and Saved file and meta details',
							});
							this.refreshStockistListEmitter();
							this.closeDialog();
						} else {
							this.openSnackbar({
								text:
									'Failed to Extracted or Saved file and meta details check logs',
							});
						}
					});
				} else {
					this.closeDialog();
					this.openSnackbar({
						text: 'Failed to register Header Mapping',
					});
				}
			}
		},
		jsonValidate(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		openRemardDialog() {
			this.remarkDialog = true;
		},
		async openHeaderMappingDialog() {
			let config = this.editorCode;
			if (this.jsonValidate(config)) {
				let fileMetaConfig = JSON.parse(config);
				config = fileMetaConfig.alternateMeta.enabled
					? fileMetaConfig.alternateMeta
					: fileMetaConfig;
				if (Object.keys(config.headerMapping).length > 0) {
					this.headersToBeMapped = {};
					for (let i in config.headerMapping) {
						this.headersToBeMapped[i] = '';
					}
					let data = await this.getHeaderMapping({
						headerMapping: this.headersToBeMapped,
					});
					if (data && data.ok) {
						this.headersToBeMapped = data.headerMapping;
					}
					this.headerMappingDialog = true;
				} else {
					this.openSnackbar({
						text: 'Format document before continuing',
					});
				}
			} else {
				this.openSnackbar({ text: 'Invalid JSON please check' });
			}
		},
		showMapping() {
			// console.log(this.headersToBeMapped)
			this.generatedMapping = this.headersToBeMapped;
			let config = this.editorCode;
			if (this.jsonValidate(config)) {
				let fileMetaConfig = JSON.parse(config);
				config = fileMetaConfig.alternateMeta.enabled
					? fileMetaConfig.alternateMeta
					: fileMetaConfig;
				config.headerMapping = {};
				for (let i in this.headersToBeMapped) {
					if (this.headersToBeMapped[i]) {
						config.headerMapping[i] = this.headersToBeMapped[i];
					}
				}
				if (fileMetaConfig.alternateMeta.enabled) {
					fileMetaConfig.alternateMeta = config;
				}
				this.editorHandler.setValue(JSON.stringify(fileMetaConfig, null, 2));
				this.headerMappingDialog = false;
			} else {
				this.openSnackbar({ text: 'Invalid JSON please check' });
			}
		},
		closeDialog() {
			this.unlockFile(this.selectedFile._id).then(data => {
				if (!data) {
					this.closeFileMetaDialog();
				}
			});
		},
		clearSelection(header) {
			this.headersToBeMapped[header] = false;
		},
		clearAllSelection() {
			for (let i in this.headersToBeMapped) {
				this.clearSelection(i);
			}
		},
		appendUnderscore() {
			if (this.jsonValidate(this.editorCode)) {
				let fileMetaConfig = JSON.parse(this.editorCode);
				if (fileMetaConfig.headerSequence.length > 0) {
					fileMetaConfig.headerSequence = fileMetaConfig.headerSequence.map(
						e => `__${e}`
					);
					this.editorHandler.setValue(JSON.stringify(fileMetaConfig, null, 2));
					this.formatConfig();
				}
			} else {
				this.openSnackbar({ text: 'Invalid JSON please check' });
			}
		},
		getProbableMetaList() {
			if (this.selectedFile.probableMetas) {
				return [
					{ text: 'Reset', value: 'Original' },
					...this.selectedFile.probableMetas.filter(e => e != null),
				];
			} else {
				return [];
			}
		},
		updateOriginalMeta(fileMetaConfig) {
			if (
				this.selectedProbableMeta == '' ||
				this.selectedProbableMeta == 'Original'
			) {
				this.originalMeta = fileMetaConfig;
			}
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'userData', 'mapableHeaders']),
		...mapGetters('rejectedMetaTwo', [
			'selectedFile',
			'extractedIdHeaders',
			'parserConfig',
			'characterHeaderSequence',
			'selectedFilesForExtraction',
		]),
	},
	watch: {
		extractedIdHeaders: function(nv) {
			if (this.jsonValidate(this.editorCode)) {
				let conf = JSON.parse(this.editorCode);
				if (conf.alternateMeta && conf.alternateMeta.enabled) {
					conf.alternateMeta.identificationHeaders = nv;
				} else {
					conf.identificationHeaders = nv;
				}
				this.editorHandler.setValue(JSON.stringify(conf, null, 2));
				this.formatConfig();
			}
		},
		parserConfig: function(nv) {
			if (this.jsonValidate(this.editorCode)) {
				this.clearHeaderMapping();
				let conf = JSON.parse(this.editorCode);
				if (conf.alternateMeta) {
					conf.alternateMeta.enabled = 1;
					if (nv.mode == 'transformv2') {
						conf.alternateMeta.extension = 'pdf';
					} else {
						conf.alternateMeta.extension = 'txt';
					}
					conf.alternateMeta.parserConfig = nv;
				}
				this.editorHandler.setValue(JSON.stringify(conf, null, 2));
				// this.formatConfig();
			}
		},
		characterHeaderSequence: function(nv) {
			// console.log("------ came here -------");
			if (this.jsonValidate(this.editorCode)) {
				let conf = JSON.parse(this.editorCode);
				conf.headerSequence = nv;
				conf.duplicateHeaders = false;
				this.editorHandler.setValue(JSON.stringify(conf, null, 2));
				this.appendUnderscore();
			}
		},
		selectedReasons: function(nv) {
			// console.log(nv, cv);
			if (this.jsonValidate(this.editorCode)) {
				let conf = JSON.parse(this.editorCode);
				if (nv.length >= 1) {
					conf.reject = true;
					conf.remarks = nv.join(' ');
				} else {
					conf.reject = false;
					conf.remarks = false;
				}
				conf.headerMapping = {};
				if (conf.alternateMeta) {
					conf.alternateMeta.identificationHeaders = [];
					conf.alternateMeta.headerMapping = {};
					conf.alternateMeta.enabled = 0;
				}
				this.editorHandler.setValue(JSON.stringify(conf, null, 2));
			}
		},
		selectedProbableMeta: function(nv) {
			this.editorHandler.clear();
			if (nv != '' && nv != 'Original') {
				this.openLoaderDialog();
				this.getFileMeta(nv).then(data => {
					this.closeLoaderDialog();
					if (data.ok) {
						// console.log('FETCHED META', JSON.stringify(data.meta, null, 2));
						this.openSnackbar({
							text: 'Updated Meta',
						});
						delete data.meta._id;
						let fileMetaConfig = JSON.parse(`{
			    "stockistId": "5cd12295a034c963ce951848",
			    "extension": "txt",
			    "actualHeaderLength": 0,
			    "enabled": 1,
			    "dateStr": -1,
			    "delimiter": false,
			    "identificationHeaders": [],
			    "headerSequence": [],
			    "duplicateHeaders": false,
			    "headerMapping": {},
			    "stockistName": "",
			    "reject": false,
			    "remarks": false,
			    "alternateMeta": {
			        "enabled": 0,
			        "extension": "txt",
			        "parserConfig": {
			            "enabled": 0,
			            "mode": "camelot",
			            "streamMode": "lattice",
			            "splitText": false,
			            "replaceNewLine": false
			        },
			        "actualHeaderLength": 0,
			        "dateStr": -1,
			        "delimiter": false,
			        "identificationHeaders": [],
			        "headerSequence": [],
			        "duplicateHeaders": false,
			        "headerMapping": {}
			    }
			}`);
						// (() => {
						// 	return require("../../components/file-meta.json");
						// })();
						this.editorHandler.setValue(
							JSON.stringify(Object.assign(fileMetaConfig, data.meta), null, 2)
						);
					}
				});
			} else if (nv == 'Original') {
				this.editorHandler.setValue(JSON.stringify(this.originalMeta, null, 2));
			}
		},
	},
	mounted() {
		this.editorHandler.clear();
		this.getFileMeta(this.selectedFile.metaUsed).then(data => {
			if (data.ok) {
				let existingMeta = JSON.parse(JSON.stringify(data.meta));
				let fileMetaConfig = JSON.parse(`{
				    "stockistId": "5cd12295a034c963ce951848",
				    "extension": "txt",
				    "actualHeaderLength": 0,
				    "enabled": 1,
				    "dateStr": -1,
				    "delimiter": false,
				    "identificationHeaders": [],
				    "headerSequence": [],
				    "duplicateHeaders": false,
				    "headerMapping": {},
				    "stockistName": "",
				    "reject": false,
				    "remarks": false,
				    "alternateMeta": {
				        "enabled": 0,
				        "extension": "txt",
				        "parserConfig": {
				            "enabled": 0,
				            "mode": "camelot",
				            "streamMode": "lattice",
				            "splitText": false,
				            "replaceNewLine": false
				        },
				        "actualHeaderLength": 0,
				        "dateStr": -1,
				        "delimiter": false,
				        "identificationHeaders": [],
				        "headerSequence": [],
				        "duplicateHeaders": false,
				        "headerMapping": {}
				    }
				}`);
				// (() => {
				// 	return require("../../components/file-meta.json");
				// })();
				this.originalMeta = ((fMC, eM) => {
					return Object.assign(fMC, eM);
				})(fileMetaConfig, existingMeta);
				this.editorHandler.setValue(JSON.stringify(this.originalMeta, null, 2));
			} else {
				let fileMetaConfig = JSON.parse(`{
					    "stockistId": "5cd12295a034c963ce951848",
					    "extension": "txt",
					    "actualHeaderLength": 0,
					    "enabled": 1,
					    "dateStr": -1,
					    "delimiter": false,
					    "identificationHeaders": [],
					    "headerSequence": [],
					    "duplicateHeaders": false,
					    "headerMapping": {},
					    "stockistName": "",
					    "reject": false,
					    "remarks": false,
					    "alternateMeta": {
					        "enabled": 0,
					        "extension": "txt",
					        "parserConfig": {
					            "enabled": 0,
					            "mode": "camelot",
					            "streamMode": "lattice",
					            "splitText": false,
					            "replaceNewLine": false
					        },
					        "actualHeaderLength": 0,
					        "dateStr": -1,
					        "delimiter": false,
					        "identificationHeaders": [],
					        "headerSequence": [],
					        "duplicateHeaders": false,
					        "headerMapping": {}
					    }
					}`);
				// (() => {
				// 	return require("../../components/file-meta.json");
				// })();
				fileMetaConfig.extension = this.selectedFile.extension;
				fileMetaConfig.stockistId = this.selectedFile.stockistId;
				fileMetaConfig.stockistName = this.selectedFile.stockistName;
				fileMetaConfig.creatorName = this.userData.name;
				this.originalMeta = fileMetaConfig;
				this.editorHandler.setValue(JSON.stringify(fileMetaConfig, null, 2));
			}
		});
	},
};
</script>

<style lang="scss" scoped></style>
